import { en } from "./translations.en";
import { fr } from "./translations.fr";
import { pt } from "./translations.pt";

export const translations = {
  en: {
    navbar: en,
  },
  fr: {
    navbar: fr,
  },
  pt: {
    navbar: pt,
  },
};
